@let route = order().route;
<onyx-information-heading class="heading">
  @let isVerified = route.isVerified;
  @let isBlocked = route.isBlocked;

  <onyx-icon-box
    titleIcon
    [color]="isVerified ? 'green' : 'gray'"
    [hasColoredBackground]="true"
    [gap]="0"
    [onyxTooltip]="`${I18N}.${isBlocked ? 'blockedRoute' : isVerified ? 'verifiedRoute' : 'notVerifiedRoute'}`"
  >
    <onyx-icon
      [name]="isBlocked ? 'locked-filled' : 'verified-filled'"
      [size]="20"
    ></onyx-icon>
  </onyx-icon-box>

  <h6>{{ 'labels.route' | translate }}</h6>

  <ng-container actions>
    <onyx-icon-button
      variant="transparent"
      color="gray"
      [size]="32"
      [icon]="isExpanded() ? 'collapse-all-outlined' : 'expand-all-outlined'"
      [circle]="true"
      [onyxTooltip]="`labels.${isExpanded() ? 'collapseAll' : 'expandAll'}`"
      (click)="toggleExpanded()"
    ></onyx-icon-button>

    @if (planRouteState(); as state) {
      <onyx-icon-button
        variant="transparent"
        color="gray"
        [size]="32"
        icon="route-outlined"
        [circle]="true"
        [disabled]="state.disabled"
        [onyxTooltip]="state.tooltip"
        (click)="planRoute()"
      ></onyx-icon-button>
    }
  </ng-container>
</onyx-information-heading>

<app-route
  [points]="order().points"
  [vehicleUuid]="order().assignedData?.vehicle?.uuid"
  [fuelType]="route.config.fuelType"
  [order]="order()"
></app-route>
